<template>
  <qx-card title="维修记录" class="detail">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='vehicleDataInfoBO.ajax?cmd=getUserRepairList'
          :params="fullSearchData"
          bizName="车辆维修记录导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
        >
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <!-- <section slot-scope="scope"></section> -->
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total || 0"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import ExportBtn from 'components/exportBtn';
import tableMixin from '@qx/mixin/table';
import {
  getUserRepairList,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  props: {
    vehicleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      downloadParams: {
        plateNumber: '',
        _ALLEXPORT: 1,
        excelLables: '时间,编号,金额,司机,司机手机,说明,审核人',
        /* eslint-disable */
        excelKeys: 'repairDate,repairCode,totalFee,userName,userBill,driverDes,audiName',
      },
      searchBoxData: {
        vehicleCode: this.$route.query.id,
        plateNumber: '',
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {
            prop: 'repairDate',
            label: '时间',
          },
          {
            prop: 'repairCode',
            label: '编号',
          },
          {
            prop: 'totalFee',
            label: '金额',
          },
          {
            prop: 'userName',
            label: '司机',
          },
          {
            prop: 'userBill',
            label: '司机手机',
          },
          {
            prop: 'driverDes',
            label: '说明',
          },
          {
            prop: 'audiName',
            label: '审核人',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getUserRepairList,
    setVehicleInfo (vehicleInfo) {
      this.searchBoxData.plateNumber = vehicleInfo.plateNumber;
      this.downloadParams.plateNumber = vehicleInfo.plateNumber;
    },
  },
};
</script>

<style>
</style>
